module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Steel + White Closed.b60fd415.png";